__turbopack_context__.v({
  "chosenEvaluation": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__chosenEvaluation",
  "details": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__details",
  "expanded": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__expanded",
  "impactContext": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__impactContext",
  "impactDetailsDescription": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__impactDetailsDescription",
  "impactDetailsExpandText": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__impactDetailsExpandText",
  "impactOutput": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__impactOutput",
  "overview": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__overview",
  "spacerRow": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__spacerRow",
  "wrapper": "DonationImpactItemAnimalWelfare-module-scss-module__NUrc5q__wrapper",
});
